export const scrollIntoView = (element: HTMLElement | null): void => {
  if (element) {
    element.scrollIntoView();
  }
};
